<template>
  <div class="receipt-container">
    <div v-if="isDataReady">
      <div
        v-for="(items, pageIndex) in hasil"
        :key="pageIndex"
        class="receipt-page"
      >
        <ReceiptHeader type="outlet" :data="outlet" />
        <div class="receipt-content">
          <h4 class="title">
            <b>Laporan Stok Per Tahun</b>
          </h4>
          <div class="info-section">
            <div class="info-row">
              <div class="info-label">Tahun:</div>
              <div class="info-value">{{ year }}</div>
            </div>
          </div>
          <div class="table-wrapper">
            <table class="detail-bon">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kode</th>
                  <th>Nama</th>
                  <th>Jan</th>
                  <th>Feb</th>
                  <th>Mar</th>
                  <th>Apr</th>
                  <th>Mei</th>
                  <th>Jun</th>
                  <th>Jul</th>
                  <th>Agu</th>
                  <th>Sep</th>
                  <th>Okt</th>
                  <th>Nov</th>
                  <th>Des</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in items" :key="k">
                  <td>{{ k + 1 }}</td>
                  <td>{{ an_item.item_code }}</td>
                  <td>{{ an_item.item_name }}</td>
                  <td>{{ an_item.jan }}</td>
                  <td>{{ an_item.feb }}</td>
                  <td>{{ an_item.mar }}</td>
                  <td>{{ an_item.apr }}</td>
                  <td>{{ an_item.mei }}</td>
                  <td>{{ an_item.jun }}</td>
                  <td>{{ an_item.jul }}</td>
                  <td>{{ an_item.agu }}</td>
                  <td>{{ an_item.sep }}</td>
                  <td>{{ an_item.okt }}</td>
                  <td>{{ an_item.nov }}</td>
                  <td>{{ an_item.des }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
import moment from 'moment'

export default {
  name: 'StockPerYearConditionPrint',
  components: {
    ReceiptHeader
  },
  data() {
    return {
      outlet: null,
      hasil: [],
      isDataReady: false,
      year: moment().format('YYYY')
    }
  },
  mounted() {
    this.getOutlet()
    this.getReport()
  },
  methods: {
    async getOutlet() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.$route.query.outlet_id}`
        )
        if (response.status === 200) {
          this.outlet = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching outlet:', error)
      }
    },
    async getReport() {
      try {
        const params = new URLSearchParams({
          year: this.year
        })
        const response = await this.$http.get(
          `${
            process.env.VUE_APP_API_URL
          }/report/stock-per-year?${params.toString()}`
        )
        if (response.status === 200) {
          this.hasil = this.splitLength(response.data.data.items, 20)
          this.isDataReady = true
          setTimeout(() => {
            window.print()
          }, 500)
        }
      } catch (error) {
        console.error('Error fetching report:', error)
      }
    },
    splitLength(array, length) {
      const result = []
      for (let i = 0; i < array.length; i += length) {
        result.push(array.slice(i, i + length))
      }
      return result
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/receipt.scss';
</style>
